<script>
  import { onMount, onDestroy } from 'svelte';
  import { getFilteredCourses } from './api';
  import CourseCard from './CourseCard.svelte';
  


  //export let filterUrl;
	export let filteredCourses =[];
  /*
  let courses = [];

  function fetchCourses() {
    getFilteredCourses(filterUrl)
      .then(response => {
        courses = response.data;
      })
      .catch(error => {
        console.error(error);
      });
  }

  onMount(fetchCourses);
  onDestroy(() => {
    courses = [];
  });
  
  function refreshCourses() {
    fetchCourses();
  }*/

</script>
  {#if !filteredCourses} 
    No results
  {:else}
    {#each filteredCourses as course}
      <CourseCard course={course} />
    {/each}
     
  {/if}

